 export const BASE_URL = "https://muskaanapi.q4hosting.com/api";
  // export const BASE_URL = "http://localhost:1721/api";
// export const BASE_URL = "https://srv22.synques.in:1721/api";
